import { makeStyles } from '@material-ui/core';
import Colors from '../../../../constants/Colors';
import { neutral, orange } from '../../../../shared/styles/colors';

export default makeStyles((theme: any) => ({
  container: {
    borderRadius: '0.5rem',
    border: `1px solid ${neutral[20]}`,
    margin: '0.5rem 0',
  },
  titleContainer: {
    borderBottom: `1px solid ${neutral.D10}`,
  },
  descriptionContainer: {
    color: neutral[60],
    fontFamily: 'PP Object Sans',
    fontWeight: 500,
    fontSize: '0.875rem',
    padding: '0 0.75rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    margin: '0.5rem 0 0 0',
  },
  cardContainer: {
    background: neutral.white,
    color: neutral.D20,
  },
  title: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    fontSize: '1rem',
  },
  quantity: {
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: neutral[100],
    paddingRight: '1rem',
  },
  chipDisclaimer: {
    padding: '0.25rem 0.5rem',
  },
  chipText: {
    fontWeight: 500,
    fontFamily: 'PP Object Sans',
  },
  headerDivider: {
    borderRight: `1px solid ${neutral.D10}`,
  },
  replaceItem: {
    color: Colors.PRIMARY_COLOR,
  },
  deleteItem: {
    color: neutral.D18,
  },
  description: {
    padding: '0.5rem 0',
    color: neutral[60],
    fontSize: '0.75rem',
    fontWeight: 400,
    fontFamily: 'PP Object Sans',
  },
  suggestionsContainer: {
    backgroundColor: orange[10],
    borderLeft: `3px solid ${orange[60]}`,
  },
  suggestionDisclaimer: {
    fontFamily: 'PP Object Sans',
    color: `${neutral[100]}`,
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  suggestionUnits: {
    fontFamily: 'PP Object Sans',
    color: neutral[80],
    fontWeight: 500,
    fontSize: '0.75rem',
  },
  suggestionName: {
    fontFamily: 'PP Object Sans',
    color: neutral[80],
    fontWeight: 500,
    fontSize: '0.75rem',
  },
  suggestionPrice: {
    fontFamily: 'PP Object Sans',
    color: neutral[80],
    fontWeight: 500,
    fontSize: '0.75rem',
  },
  alertMessage: {
    margin: '1.25rem 0',
  },
  toppingCategory: {
    color: neutral[80],
    fontSize: '0.75rem',
    fontWeight: 400,
    fontFamily: 'PP Object Sans',
  },
  toppingDescription: {
    fontFamily: 'PP Object Sans',
    fontWeight: 500,
    color: neutral[100],
    fontSize: '1rem',
    width: '100%',
  },
  cardFooter: {
    padding: '1.25rem 1rem',
    [theme.breakpoints.up('md')]: {
      padding: '0 1rem 1.25rem 1rem',
    },
  },
  subtotal: {
    fontWeight: 600,
  },
  corridorName: {
    color: Colors.PRIMARY_COLOR,
    fontSize: '0.75rem',
    fontWeight: 600,
    marginTop: '1rem',
    '&::first-letter': {
      textTransform: 'uppercase',
    },
  },
  suggestionContainer: {
    padding: 0,
    paddingLeft: '1rem',
    listStyle: 'disc',
  },
  suggestionItem: {
    color: neutral[80],
    display: 'list-item',
    fontSize: '0.5rem',
    padding: 0,
  },
}));
